'use strict'

function addOrRemoveClasListIsVisibleToScrollPosition(element, offset, marge){
    // si element et offset existent
    if(element && offset){
        element.classList.add("isVisible") // ajoute la class css
        if( (window.pageYOffset + element.offsetTop) > offset.offsetTop - marge ){
            element.classList.remove("isVisible")
        }
        else{
            element.classList.add("isVisible") 
        }
    }
}

export default addOrRemoveClasListIsVisibleToScrollPosition;


// WEBPACK FOOTER //
// ./src/scripts/components/AddClassListIsVisible.js